const shape = {
    borderRadius: 4,
    borderRadiusSmall: 4,
    borderRadiusSmallMedium: 6,
    borderRadiusMedium: 8,
    borderRadiusMediumLarge: 12,
    borderRadiusLarge: 18,
    reallyBig: 24,
} as const

export default shape
